'use strict';
import * as $j_app$002epages$002e$002dDocument$002dTemplates$002dCreate$002dPage$0024$002dArgs from "./app.pages.-Document-Templates-Create-Page$-Args.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_DocumentTemplatesCreatePage$Args$$anon$1(\u03b4name$3, _$ordinal$3) {
  this.aia = null;
  this.aXy = 0;
  this.aia = \u03b4name$3;
  this.aXy = _$ordinal$3;
}
export { $c_Lapp_pages_DocumentTemplatesCreatePage$Args$$anon$1 as $c_Lapp_pages_DocumentTemplatesCreatePage$Args$$anon$1 };
$p = $c_Lapp_pages_DocumentTemplatesCreatePage$Args$$anon$1.prototype = new $j_app$002epages$002e$002dDocument$002dTemplates$002dCreate$002dPage$0024$002dArgs.$h_Lapp_pages_DocumentTemplatesCreatePage$Args();
$p.constructor = $c_Lapp_pages_DocumentTemplatesCreatePage$Args$$anon$1;
/** @constructor */
function $h_Lapp_pages_DocumentTemplatesCreatePage$Args$$anon$1() {
}
export { $h_Lapp_pages_DocumentTemplatesCreatePage$Args$$anon$1 as $h_Lapp_pages_DocumentTemplatesCreatePage$Args$$anon$1 };
$h_Lapp_pages_DocumentTemplatesCreatePage$Args$$anon$1.prototype = $p;
$p.s = (function() {
  return 0;
});
$p.e = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.u = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.t = (function() {
  return this.aia;
});
$p.n = (function() {
  return this.aia;
});
$p.co = (function() {
  return this.aXy;
});
$p.U = (function(p) {
  return this;
});
var $d_Lapp_pages_DocumentTemplatesCreatePage$Args$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_DocumentTemplatesCreatePage$Args$$anon$1, "app.pages.DocumentTemplatesCreatePage$Args$$anon$1", ({
  Ht: 1,
  kf: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1,
  r: 1,
  d: 1,
  e: 1,
  k: 1
}));
export { $d_Lapp_pages_DocumentTemplatesCreatePage$Args$$anon$1 as $d_Lapp_pages_DocumentTemplatesCreatePage$Args$$anon$1 };
//# sourceMappingURL=app.pages.-Document-Templates-Create-Page$-Args$$anon$1.js.map
